(ns frontend.ui.component.lp-portal.report.body.feeder.feeder.web
  (:require
   [frontend.ui.component.lp-portal.report.module.tabular-card :as tabular-card]
   [frontend.ui.component.lp-portal.report.module.free-text-card :as free-text-card]
   [frontend.ui.component.grid.view :as grid]
   [frontend.ui.component.dynamic-table.view :as dynamic-table]
   [frontend.ui.component.lp-portal.text-content.view :as text-content]
   [frontend.ui.component.lp-portal.card.view :as card]))

(defn feeder
  [{:keys [fund-ui-data] :as props}]
  (let [{:keys [basic-information-primary basic-information-secondary overview summary investors]}
        fund-ui-data]
    [:div
     [:div
      [card/card
       {:title "Basic information"}
       [:div
        [dynamic-table/dynamic-stack (:figures basic-information-primary)]
        (text-content/optional-footnote basic-information-primary props)]
       [:div
        [dynamic-table/dynamic-stack (:figures basic-information-secondary)]
        (text-content/optional-footnote basic-information-secondary props)]]]
     [:div
      [grid/row {}
       [grid/column {:large 6}
        [tabular-card/dynamic-table "Summary" summary props]]
       [grid/column {:large 6}
        [free-text-card/view "Overview" overview props]]]]

     [:div
      [tabular-card/dynamic-table "Investors, €" investors props]]]))
